import React, { Component } from 'react'
import { Form, Row, Col, Input, Select, Table, Button, Drawer, Icon, Modal, message } from 'antd'

import { Link } from 'react-router-dom'

import { getStatusName } from './tableconfig/goodTable'

import GoodsSpecsTable from './component/GoodsSpecsTable'
import GoodsExamineModel from './component/GoodsExamineModel'
import { getGoodList, getGoodsStatus, goodsCategoryList, grounding } from '_src/api/api'

import Log from './log'

import PrevImg from '_src/components/PrevImg/PrevImg'

import './style/index.less'

const { Search } = Input
const { Option } = Select
const { confirm } = Modal

class GoodList extends Component {
  constructor (props) {
    super(props)
    this.pageNum = 0
    this.totalElements = 0
    this.goodsName = ''
    this.goodParam = {
      id: '',
      goodsName: ''
    }
    this.state = {
      tableLoading: true,
      loading: false,
      dataList: [],
      goodsCategoryList: [],
      visible: false,
      statusBtns: [],
      status: ''
    }
  }

  componentDidMount () {
    this.LoadData()
    this.LoadGoodsStatus()
    this.loadGoodsCategory()
  }
  LoadData = (callback) => {
    const { status } = this.state
    this.setState(() => ({
      tableLoading: true
    }))
    getGoodList({
      status,
      pageSize: 10,
      pageNum: this.pageNum,
      goodsName: this.goodsName,
      goodsCategoryId: this.goodsCategoryId })
      .then(res => {
        callback && callback()
        const { data: { content, totalElements }} = res
        this.setState(() => ({
          tableLoading: false
        }))
        this.totalElements = totalElements
        const dataList = content && content.map(item => {
        // 商品名称， 收藏， 商品编号， 图片链接, 状态，分享
        // goodSpecifications 商品规格
          const { goodsName, collect, goodsSn, picUrl, status, share, goodsReward, goodSpecifications, id, goodsAudit } = item
          const baseInfo = { goodsName, collect, goodsSn, picUrl, status, share, goodsReward, goodSpecifications }
          /**
         * goodsReward 商品积分{
         * `watchCount`  '观看视频时常 单位秒', 
         * `watchReward` '观看视频时常 获得多少积分',   
         * `browsCount`   浏览商品时常 单位秒',  
         * `browsReward` '浏览商品时常 获得多少积分',   
         * `totalCount`  '该商品设置的总积分'}
         */

          const { watchCount, watchReward, browsCount, browsReward } = goodsReward ||
          { watchCount: '无', watchReward: '无', browsCount: '无', browsReward: '无' }
          const { message } = goodsAudit || { message: '' } // 留言
          const RewardInfo = { watchCount, watchReward, browsCount, browsReward }
          return { key: goodsSn, ...baseInfo, ...RewardInfo, id, message }
        })

        this.setState(() => ({
          dataList: [...dataList],
        }))
      })
  }
  LoadGoodsStatus () {
    getGoodsStatus().then(res => {
      const { data } = res
      // console.log(data)
      const arr = data.map(item=>{
        item.status = item.status === '总数'? '' : item.status
        return {text: getStatusName(item.status).text, num: item.count, id: item.status}
      })
      this.setState({
        statusBtns: arr
      })
    })
  }

  // 状态按钮搜索
  handleBtnSearch = (status) => {
    this.setState({
      status
    }, ()=>{
      this.pageNum = 0
      this.LoadData()
    })
  }
  // 获取商品分类
  loadGoodsCategory () {
    goodsCategoryList()
      .then(res=>{
        const { data } = res
        this.setState({
          goodsCategoryList: data.content
        })
      })
  }
  setTableLoad () {
    this.setState(() => ({
      tableLoading: true
    }))
  }

  // 上下架操作
  handleGrounding (record) {
    const { goodsName, id, status } = record
    const groundingMName = status === 1? '下架':'上架'
    const self = this 
    if (status === 0 || status === 1 || status === 2) {
      confirm({
        title: '温馨提示',
        content: (
          <p>您确定要将商品<span style = {{color: 'red', fontWeight: 'bold'}}>{goodsName}</span>{groundingMName}吗</p>
        ),
        onOk () {
          const statusParam = status === 1? 2 : 1 
          const hide = message.loading(`${groundingMName}中`, 0)
          grounding(id, statusParam)
            .then(()=>{
              hide()
              self.LoadData()
            })
            .catch(()=>{
              hide()
              message.error('请求超时，请稍后再试')
            })
        },
        onCancel () {
        
        },
      })
    }
    else {
      confirm({
        title: '温馨提示',
        content: (
          <p>
            该商品处于
            <span style={{ color: getStatusName(status).color, marginRight: 10 }}>{getStatusName(status).text}</span>,
            不能上架
          </p>
        ),
        onOk () {}
      })
    }
  }

  columns = () => ([
    {
      title: '商品ID',
      dataIndex: 'id',
    },
    {
      title: '商品图片',
      dataIndex: 'picUrl',
      render: (url) => <img src={url} style={{ width: 100 }} alt="" onClick={() => this.PrevImg.show(url)} />
    },
    {
      title: '编号',
      dataIndex: 'goodsSn',
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
    },
    //   {
    //     title: '销量',
    //     dataIndex: 'volume',
    //   },
    {
      title: '收藏',
      dataIndex: 'collect',
      align: 'center',
      render: item => item || 0
    },
    {
      title: '分享',
      dataIndex: 'share',
      align: 'center',
      render: item => item || 0
    },
    {
      title: '浏览商品奖励',
      width: 150,
      render: item => (
        item.goodsReward && item.goodsReward.browsCount 
          ? (
            <div>
              <div>浏览时长：{item.goodsReward.browsCount} 秒</div>
              <div>奖励积分：{item.goodsReward.browsReward}</div>
            </div>
          )
          : '无奖励'
      )
    },
    {
      title: '观看视频奖励',
      width: 150,
      render: item => (
        item.goodsReward && item.goodsReward.watchReward 
          ? (
            <div>
              <div>观看时长：{item.goodsReward.watchCount} 秒</div>
              <div>奖励积分：{item.goodsReward.watchReward}</div>
            </div>
          )
          : '无奖励'
      ),
    },
    {
      title: '审核状态',
      dataIndex: 'status',
      render: (status, record) => (
        <div className="examine">
          <span style={{ color: getStatusName(status).color }}>{getStatusName(status).text}</span>
          <Button size="small" type="primary" style={{ paddingLeft: 5, paddingRight: 5 }}
            onClick={() => { this.ExamineModel.showExamineModel(record) }}
          >审核</Button>
          <Button type="link" onClick={() => { this.ExamineModel.showExamineModel(record, 'watch') }}>审核详情</Button>
        </div>
      )
    },
    {
      title: '操作',
      dataIndex: 'opt',
      render: (_, record) => (
        <div className="opt_btn">
          <div className="opt_btn_list">
            <Link to={{ pathname: '/goods/detail?id=' + record.id }} target='_blank'>
              <Button type="link">查看</Button>
            </Link>
          </div>
          <div className="opt_btn_list">
            <Button type="link" onClick={() => { this.openDrawer(record) }}>日志</Button>
          </div>
          <div className="opt_btn_list">
            <Button type="link" onClick={()=>{ this.handleGrounding(record) }}
                style = {{ color: record.status===1?'red':'' }}
            >
                {record.status === 1?'下架':'上架'}
            </Button>
          </div>
        </div>
      )
    }
  ])

  // 订阅更新
  handleLoad = (callback) => {
    this.LoadData(callback)
  }
  onSearchName = (value) => {
    this.pageNum = 0
    this.goodsName = value
    this.setTableLoad()
    this.LoadData()
  }

  // 打开抽屉
  openDrawer (record) {
    const { goodsName, id } = record
    this.goodParam.goodsName = goodsName
    this.goodParam.id = id
    this.setState(()=>({
      visible: true
    }))
  }
// 关闭抽屉
onClose = () =>{
  this.setState({
    visible: false
  })
}

SelectChange = (v) => {
  this.goodsCategoryId = v
  this.LoadData()
}

pageChange (pageNum) {
  this.setTableLoad()
  this.pageNum = pageNum - 1
  this.LoadData()
}

render () {
  const { dataList, tableLoading, visible, goodsCategoryList, statusBtns, status} = this.state
  const drawerHeader = (
    <div className = "page_top">
      <p className = "page_top_title">
        商品日志-<span style = {{color: 'red'}}>{this.goodParam.goodsName}</span>
      </p>
      <div className = "returnDetail_btn">
        <Button className = "" type="primary" onClick = {this.onClose}>
          <Icon type="left" />
          返回
        </Button>
      </div>
    </div>
  )
  return (
    <div className = 'GoodList'>
      <PrevImg ref={el => this.PrevImg = el} />
      <div className = "top" >
        {
          statusBtns.map((item, index)=>(
            <SearchButton key = {index} id = {item.id} state = {status} handleSearch = {this.handleBtnSearch} label = {item} />
          ))
        }
      </div>
      <PrevImg ref={el => this.PrevImg = el} />
      <Form className="goodlist_from">
        <div style={{ maxWidth: 900 }}>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label="商品名称" >
                <Search placeholder="请输入商品名称" onSearch={this.onSearchName} enterButton />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="商品分类">
                <Select placeholder="请选择商品分类" showSearch onChange = {this.SelectChange} >
                  <Option value="">全部</Option>
                  {
                    goodsCategoryList.map((item, index)=>{
                      return (<Option key = {index} value= {item.id}>{item.name}</Option>)
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="商家名称" >
                <Search placeholder="请输入商家" onSearch={this.onSearchName} enterButton />
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
      <div className="good_table">
        {/* <div style={{ marginBottom: 16 }}>
            <Button type="primary" onClick={this.start} disabled={!hasSelected} loading={loading}>
            Reload
            </Button>
            <span style={{ marginLeft: 8 }}>
              {hasSelected ? `Selected ${selectedRowKeys.length} items` : ''}
            </span>
          </div> */}
        <Table
          loading={tableLoading}
          bordered
          size="middle"
          // rowSelection={rowSelection} 
          columns={this.columns()}
          dataSource={dataList}
          expandedRowRender={(record) => (<GoodsSpecsTable param={record} />)}
          pagination={{
            current: (this.pageNum + 1),
            total: this.totalElements,
            onChange: (page) => { this.pageChange(page) }

          }}
        />
      </div>
      <GoodsExamineModel wrappedComponentRef={ExamineModel => { this.ExamineModel = ExamineModel }} subscribeLoad={this.handleLoad} />
      <Drawer
        title={drawerHeader}
        width={'900'}
        onClose={this.onClose}
        destroyOnClose
        closable = {false}
        visible = {visible}
      >
        <span>日志信息</span>
        <Log id = {this.goodParam.id} />
      </Drawer>
    </div>
  )
}


}

const SearchButton = (props) => {
  function handleClick (id) {
    const { handleSearch } = props   
    // const { handleSearch } = this.props
    handleSearch && handleSearch(id)
  }
  const { label, state, id} = props
  const { text, num } = label|| {}
  return (
    <Button className = {`filterBtn ${state === id?'act':''}`} onClick = {()=>{ handleClick(id) }}>
      {text}<span className = "num">{num&&`（${num}）`}</span>
    </Button>
  )
}

export default Form.create({ name: 'register' })(GoodList)